import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aafbe64"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customerName" }, [
  /*#__PURE__*/_createTextVNode("Name"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "subject" }, [
  /*#__PURE__*/_createTextVNode("Subject"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "requestType" }, [
  /*#__PURE__*/_createTextVNode("Request Type"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choose a request type", -1))
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "requestReason" }, [
  /*#__PURE__*/_createTextVNode("Request Reason"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choose a request reason", -1))
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "relatedEvent" }, "Related Event", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "contact-form__hint" }, " If you can't find your event here, leave blank and reference any event details in the description box below. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Description"),
  /*#__PURE__*/_createElementVNode("span", { "aria-label": "Required" }, "*")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "secondary-button",
  type: "submit",
  value: "Submit"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_search_box = _resolveComponent("search-box")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    class: "contact-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_Field, {
          name: "customerName",
          id: "customerName",
          modelValue: _ctx.formData.customerName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.customerName) = $event)),
          type: "text",
          "aria-describedby": "customerName__error",
          rules: _ctx.validation.customerName
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "customerName__error",
          class: "contact-form__error",
          name: "customerName"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_Field, {
          name: "email",
          id: "email",
          modelValue: _ctx.formData.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.email) = $event)),
          type: "text",
          "aria-describedby": "email__error",
          rules: _ctx.validation.email
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "email__error",
          class: "contact-form__error",
          name: "email"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_Field, {
          name: "subject",
          id: "subject",
          modelValue: _ctx.formData.subject,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.subject) = $event)),
          type: "text",
          "aria-describedby": "subject__error",
          rules: _ctx.validation.subject
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "subject__error",
          class: "contact-form__error",
          name: "subject"
        })
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_Field, {
          name: "requestType",
          id: "requestType",
          modelValue: _ctx.formData.requestType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.requestType) = $event)),
          as: "select",
          "aria-describedby": "requestType__error",
          rules: _ctx.validation.requestType
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestTypes, (requestType) => {
              return (_openBlock(), _createElementBlock("option", {
                key: requestType.value,
                value: requestType.value,
                selected: 
            requestType.value &&
            _ctx.formData.requestType.includes(requestType.value)
          
              }, _toDisplayString(requestType.label), 9, _hoisted_6))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "requestType__error",
          class: "contact-form__error",
          name: "requestType"
        })
      ]),
      (_ctx.showRequestReason)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Field, {
              name: "requestReason",
              id: "requestReason",
              modelValue: _ctx.formData.requestReason,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.requestReason) = $event)),
              as: "select",
              "aria-describedby": "requestReason__error",
              rules: _ctx.validation.requestReason
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestReasons, (requestReason) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: requestReason.value,
                    value: requestReason.value,
                    selected: 
            requestReason.value &&
            _ctx.formData.requestReason.includes(requestReason.value)
          
                  }, _toDisplayString(requestReason.label), 9, _hoisted_10))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "rules"]),
            _createVNode(_component_ErrorMessage, {
              id: "requestReason__error",
              class: "contact-form__error",
              name: "requestReason"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEventSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_search_box, {
              label: "Search for event...",
              modelValue: _ctx.relatedEvent.currentRefinement,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.relatedEvent.currentRefinement) = $event)),
              onSubmit: _ctx.onSearchSubmit,
              hits: _ctx.relatedEvent.hits,
              "show-search-for": false,
              theme: "blue"
            }, {
              default: _withCtx(({ hit }) => [
                _createElementVNode("button", {
                  class: "related-event-search__suggestion",
                  onClick: ($event: any) => (_ctx.selectRelatedEvent(_ctx.formatEventDescription(hit)))
                }, _toDisplayString(_ctx.formatEventDescription(hit)), 9, _hoisted_13)
              ]),
              _: 1
            }, 8, ["modelValue", "onSubmit", "hits"]),
            _hoisted_14
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_15,
        _createVNode(_component_Field, {
          name: "description",
          modelValue: _ctx.formData.description,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.description) = $event)),
          "aria-describedby": "description__error",
          rules: _ctx.validation.description
        }, {
          default: _withCtx(({ field }) => [
            _createElementVNode("textarea", _mergeProps({ id: "description" }, field, { rows: "5" }), null, 16)
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createVNode(_component_ErrorMessage, {
          id: "description__error",
          class: "contact-form__error",
          name: "description"
        })
      ]),
      _hoisted_16
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}